import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    label: "电影",
    desc: "院线新片与经典佳作",
    icon: "ri-movie-2-line",
  },
  {
    to: "/category/tv",
    label: "电视剧",
    desc: "热播剧集持续更新中",
    icon: "ri-tv-2-line",
  },
  {
    to: "/search",
    label: "最新上线",
    desc: "近一年新作抢先看",
    icon: "ri-calendar-schedule-line",
  },
  {
    to: "/search",
    label: "热门推荐",
    desc: "全网高热度精选",
    icon: "ri-fire-line",
  },
];

export default function QuickEntries() {
  return (
    <section className="w-full px-4 md:px-6 -mt-10 md:-mt-14 relative z-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4">
        {entries.map((e, i) => (
          <Link
            key={e.label}
            to={e.to}
            className={`group relative flex items-center gap-3 px-3 md:px-5 py-3.5 md:py-5 rounded-lg border transition-colors cursor-pointer cc-fade-up ${
              i === 3
                ? "bg-accent-500 border-accent-500 hover:bg-accent-400"
                : "bg-background-50 border-background-200 hover:border-secondary-400"
            }`}
            style={{ animationDelay: `${i * 70}ms` }}
          >
            <span
              className={`w-10 h-10 md:w-11 md:h-11 rounded-md flex items-center justify-center text-lg shrink-0 ${
                i === 3 ? "bg-primary-950 text-accent-400" : "bg-primary-50 text-primary-600"
              }`}
            >
              <i className={e.icon} />
            </span>
            <span className="min-w-0">
              <span
                className={`block font-heading text-sm md:text-base font-bold ${
                  i === 3 ? "text-primary-950" : "text-foreground-950"
                }`}
              >
                {e.label}
              </span>
              <span
                className={`block text-[11px] md:text-xs mt-0.5 truncate ${
                  i === 3 ? "text-primary-800" : "text-foreground-500"
                }`}
              >
                {e.desc}
              </span>
            </span>
            <i
              className={`hidden md:flex ri-arrow-right-up-line ml-auto w-4 h-4 items-center justify-center text-base transition-transform group-hover:translate-x-0.5 ${
                i === 3 ? "text-primary-800" : "text-foreground-400"
              }`}
            />
          </Link>
        ))}
      </div>
    </section>
  );
}